<template>
  <div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref="eventAdditionalModal"
      id="eventAdditionalModal"
      hide-header
      hide-footer
      size="md"
    >
      <h4 class="text-center">Note</h4>
      <div>
        <div class="seat-name-card my-3">
          <div>
            <div class="mb-2 seat-type-card">
              <div>
                <p>
                  {{ eventDetails.additional_information }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="seat-type-buttons">
          <button class="btn btn-cancel" @click="hideAdditionalModal()">
            CANCEL
          </button>
          <button class="btn btn-pink" @click="showSeatTypeModal">OK</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref="eventSeatTypeModal"
      id="eventSeatTypeModal"
      hide-header
      hide-footer
      size="md"
    >
      <!-- <h4 class="text-center">Select Your Preference</h4> -->
      <div>
        <h5 class="text-pink text-center mb-3">Select Category</h5>
        <div
          class="seat-name-card"
          v-for="(seatName, seatNameindex) in this.eventSeatType"
          :key="seatNameindex"
        >
          <!-- <h5 class="text-pink">{{ seatName.aa_name }}</h5> -->
          <div
            v-for="(seatType, seatTypeIndex) in seatName.seat_type"
            :key="seatTypeIndex"
          >
            <div class="mb-2 seat-type-card">
              <div>
                <p>
                  {{ seatType.st_name }} -
                  {{ seatType.price }}
                  {{ seatType.currency }}
                </p>
              </div>
              <div class="grid-counter">
                <span @click="countSeatType('minus', seatName, seatType)"
                  >-</span
                >
                <div>
                  <p>
                    {{ seatType.no_of_seat || 0 }}
                  </p>
                </div>
                <span
                  class="plus-icon"
                  @click="countSeatType('add', seatName, seatType)"
                  >+</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="seat-type-buttons mt-2">
          <button class="btn btn-cancel" @click="hideSeatTypeModal()">
            CANCEL
          </button>
          <button class="btn btn-pink" @click="routePaymentPage()">BOOK</button>
        </div>
      </div>
    </b-modal>
    <div class="wrapper wrapper_mob event-details-page pb-5">
      <div class="go-back">
        <a
          @click="$router.go(-1)"
          style="cursor: pointer"
          class="font-weight-bold"
          >Go back
        </a>
      </div>
      <div class="container-fluid event-detail-contain-mobile">
        <div class="row event-details-header justify-content-center">
          <div class="col-md-3 px-0 d-lg-block d-none">
            <img
              :src="base_url + eventDetails.e_image"
              class="w-100 h-100 event-banner-img"
            />
          </div>
          <div class="col-12 mb-2 px-0 d-block d-lg-none">
            <div
              v-for="(data, index) in this.eventDetails.e_banners"
              :key="index"
            >
              <img
                :src="base_url + data.e_banner"
                class="w-100 h-100 event-banner-img"
              />
            </div>
          </div>
          <div class="col-lg-9 mt-2 col-12 mt-lg-0">
            <div>
              <h3
                class="
                  text-pink
                  events-movie-heading
                  mt-lg-3
                  mb-0
                  text-mobile-head
                "
              >
                {{ eventDetails.e_name }}
              </h3>
              <div class="event-genre d-none d-md-flex">
                <div>
                  <span>{{ eventDetails.rating }}</span>
                </div>
                <div v-for="(data, index) in eventDetails.e_genre" :key="index">
                  <span v-if="data.e_genre !== (null || '')">
                    {{ data.e_genre }}
                  </span>
                </div>
              </div>
              <read-more
                more-str="read more "
                :text="eventDetails.e_s_description.toString()"
                link="#"
                less-str="read less"
                :max-chars="220"
                class="read-more mt-1 mt-lg-2"
              ></read-more>
              <div
                v-if="eventDetails.es_date == eventDetails.ee_date"
                class="mt-lg-3 mt-1"
              >
                <div class="row">
                  <div class="col-xl-3 col-6">
                    <div class="small">Event Date</div>
                    <div class="d-flex align-items-center">
                      <img
                        src="@/assets/img/icons/calendar.svg"
                        height="16px"
                        width="16px"
                        alt
                        class="mr-1"
                      />
                      {{ moment(eventDetails.ee_date).format("MMM D / YYYY") }}
                    </div>
                  </div>
                  <div class="col-xl-3 col-6" v-if="eventSchedule.length == 1">
                    <div class="small">Event Timing</div>
                    <div class="d-flex align-items-center">
                      <img
                        src="@/assets/img/icons/calendar.svg"
                        height="16px"
                        width="16px"
                        alt
                        class="mr-1"
                      />
                      {{
                        moment(eventTimings[0].es_time, "h:mm a").format(
                          "h:mm a"
                        )
                      }}
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="small">Location</div>
                    <span>{{ eventDetails.venue[0].ev_name }}</span>
                    <div class="d-flex align-items-center">
                      <a
                        target="_blank"
                        class="direction-color"
                        :href="`http://www.google.com/maps/place/+${eventDetails.venue[0].ev_lat},${eventDetails.venue[0].ev_long}`"
                        >Click Here</a
                      >
                    </div>
                  </div>
                </div>
                <button
                  v-if="!stop_sale"
                  class="btn btn-pink mt-2 mobile-width-btn"
                  @click="
                    showAdditionalModal(
                      eventTimings[0].event_schedule_id,
                      eventTimings[0],
                      'single'
                    )
                  "
                >
                  Book Now
                </button>
              </div>
              <div v-else class="mt-lg-3">
                <div class="row">
                  <div class="col-xl-3 col-6">
                    <div class="small">Start Date</div>
                    <div class="d-flex align-items-center">
                      <img
                        src="@/assets/img/icons/calendar.svg"
                        height="16px"
                        width="16px"
                        alt
                        class="mr-1"
                      />
                      {{ moment(eventDetails.es_date).format("MMM. D, YYYY") }}
                    </div>
                  </div>
                  <div class="col-xl-3 col-6">
                    <div class="small">End Date</div>
                    <div class="d-flex align-items-center">
                      <img
                        src="@/assets/img/icons/calendar.svg"
                        height="16px"
                        width="16px"
                        alt
                        class="mr-1"
                      />
                      {{ moment(eventDetails.ee_date).format("MMM. D, YYYY") }}
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="small">Location</div>
                    <span>{{ eventDetails.venue[0].ev_name }}</span>
                    <div class="d-flex align-items-center">
                      <a
                        target="_blank"
                        class="direction-color"
                        :href="`http://www.google.com/maps/place/+${eventDetails.venue[0].ev_lat},${eventDetails.venue[0].ev_long}`"
                        >Click Here</a
                      >
                    </div>
                  </div>
                </div>
                <button
                  v-if="!showDateTime"
                  class="btn btn-pink mt-2"
                  @click="showDateTimeFn"
                >
                  Book Now
                </button>
              </div>
              <div class="mt-3">
                <div class="mt-2 mb-2" v-if="this.eventVideos.length > 0">
                  <div :class="['small d-flex']">Video</div>
                  <div
                    class="d-flex position-relative"
                    style="min-height: 118px"
                  >
                    <div
                      v-for="(trailer, youtubeKey) in this.eventVideos"
                      :key="youtubeKey"
                      v-bind:style="{
                        'background-image': 'url(' + trailer.thumbnail + ')',
                      }"
                      class="trailer-box"
                    >
                      <a :href="trailer.url" data-fancybox class="btn-play"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row showtimes-section mt-4 mb-3"
          v-if="
            (showDateTime && eventDetails.es_date != eventDetails.ee_date) ||
            (eventDetails.es_date == eventDetails.ee_date &&
              eventSchedule.length > 1)
          "
          id="showtimes-section"
        >
          <div class="col-lg-12 px-0">
            <h5>Event Dates</h5>
            <div class="custom-shadow mt-2">
              <div>
                <Slick
                  ref="eventDateFlex"
                  :options="dateCardSlider"
                  v-if="eventSchedule.length > 0"
                  class="event-date-slider"
                >
                  <div
                    v-for="(data, index) in eventSchedule"
                    :key="index"
                    @click="
                      getEventTimings(data.es_date, data.event_schedule_id)
                    "
                  >
                    <div
                      class="event-date-card"
                      :class="
                        selectedDate == data.event_schedule_id
                          ? 'date-card-active'
                          : ''
                      "
                    >
                      <!-- <span class="month">{{
                      moment(data.es_date).format("MMM")
                    }}</span> -->
                      <span class="date">{{
                        moment(data.es_date).format("D")
                      }}</span>
                      <span class="day">{{
                        moment(data.es_date).format("ddd")
                      }}</span>
                    </div>
                  </div>
                </Slick>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-3 px-0" v-if="!stop_sale">
            <div class="custom-shadow">
              <h6 class="mx-3">Select Timings</h6>
              <div class="event-time-flex mt-3">
                <div
                  v-for="(data, index) in eventTimings"
                  :key="index"
                  class="event-time-card"
                  :class="
                    selected_schedule_id == data.event_schedule_id
                      ? 'date-card-active'
                      : ''
                  "
                  @click="showAdditionalModal(data.event_schedule_id, data)"
                >
                  {{ moment(data.schedule_time, "h:mm a").format("h:mm a") }}
                </div>
              </div>
              <button class="btn btn-pink mt-3 mx-3" @click="bookNowEvent">
                Book Now
              </button>
            </div>
          </div>
        </div>
        <div
          class="
            row
            event-details-accordion
            custom-shadow
            mt-3
            py-3
            event-detail-content-mobile
          "
        >
          <div class="col-lg-12">
            <div class="accordion" role="tablist">
              <!--About Info-->
              <div>
                <div header-tag="header" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-1
                    variant="info"
                    class="
                      d-flex
                      text-capitalize
                      btn_acc
                      justify-content-between
                      align-items-center
                    "
                  >
                    About Events
                    <img
                      src="@/assets/img/icons/chevron-left-pink.svg"
                      class="acc_img"
                    />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-1"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <div v-html="eventDetails.e_description"></div>
                  <!-- <p>
                  {{ eventDetails.e_description }}
                </p> -->
                </b-collapse>
              </div>

              <!--Organizer Info-->
              <div class="my-3">
                <div header-tag="header" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-2
                    variant="info"
                    class="
                      d-flex
                      text-capitalize
                      btn_acc
                      justify-content-between
                      align-items-center
                    "
                  >
                    Organizer Info
                    <img
                      src="@/assets/img/icons/chevron-left-pink.svg"
                      class="acc_img"
                    />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <div v-for="(data, index) in eventDetails.organiser_details">
                    <!-- {{ eventDetails.organiser_details.map((data) => {
                      console.log(data);
                  }) }} -->
                    <!-- {{ data }} -->
                    <h6 class="font-weight-bold mb-0">{{ data.od_name }}</h6>
                    <p v-html="data.od_sdescription"></p>
                    <div>
                      <p>
                        <i class="fa fa-trash" aria-hidden="true"></i>
                        {{ data.od_email }}
                      </p>
                      <p>{{ data.od_mobile }}</p>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!--Terms and condition Info-->
              <div>
                <div header-tag="header" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-3
                    variant="info"
                    class="
                      d-flex
                      text-capitalize
                      btn_acc
                      justify-content-between
                      align-items-center
                    "
                  >
                    Terms And Condition
                    <img
                      src="@/assets/img/icons/chevron-left-pink.svg"
                      class="acc_img"
                    />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <p v-html="eventDetails.terms_condition">
                    <!-- {{  }} -->
                  </p>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { EVENT_URL } from "@/helper/constant.js";
import moment from "moment";
import { CountryService } from "@/services/storage.service";
import { EventBus } from "@/main";

export default {
  components: {
    Slick,
  },
  data() {
    return {
      stop_sale: true,
      moment,
      dateCardSlider: {
        arrows: true,
        slidesToShow: 20,
        // centerMode: true,
        // centerPadding: "3.5%",
        timingsData: "",
        slidesToScroll: 1,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 7000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: true,
              dots: false,
              // centerMode: false,
              slidesToShow: 5,
              // autoplaySpeed: 7000,
              // autoplay: true,
              infinite: false,
              slidesToScroll: 1,
            },
          },
        ],
      },
      selected_schedule_id: 0,
      url: EVENT_URL,
      eventDetails: [],
      eventSchedule: [],
      eventSeatType: [],
      eventTimings: [],
      eventVideos: [],
      selectedDate: "",
      eventSeatName: null,
      showDateTime: false,
      base_url: "",
    };
  },
  computed: {
    ...mapGetters(["getSelectedSeats", "getSelectedSeatName"]),
  },
  mounted() {
    const { eventID } = this.$route.params;
    console.log(this.$route.params);
    this.getEventDetails(eventID);
  },
  created() {},
  methods: {
    ...mapActions([
      "addSelectedEvent",
      "addSelectedSchedule",
      "addSelectedSeats",
      "removeSelectedSeats",
      "addSelectedSeatName",
      "removeAllSelectedSeats",
    ]),
    openFancyBox() {
      $("a.btn-play").fancybox({
        zoomSpeedIn: 300,
        zoomSpeedOut: 300,
        overlayShow: false,
      });
    },
    showDateTimeFn(type) {
      this.showDateTime = !this.showDateTime;
      setTimeout(() => {
        let elmnt = document.getElementById("showtimes-section");
        elmnt.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });
      }, 0);
    },
    getEventDetails(id) {
      this.showLoading();
      this.$cookies.set("retry_type", "event", "1d");
      this.$cookies.set("retry_id", id, "1d");
      makeRequest("/v1/event/details/" + id, "POST", null, null, this.url)
        .then((response) => {
          const { error, res } = response;
          if (!error) {
            this.hideLoading();
            this.base_url = res.data.base_url;
            this.eventDetails = res.data.data;
            this.stop_sale = this.eventDetails.stop_sale == 1 ? true : false;
            console.log(
              "object :>> ",
              this.eventDetails.stop_sale,
              this.stop_sale
            );
            console.log(this.eventDetails.country_id);
            let country = {};
            if (this.eventDetails.country_id == 175) {
              country.CountryID = 175;
              country.CountryISOCode = "974";
              country.CountryName = "Qatar";
              country.Flag =
                "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c77d4dc4e13c.jpg";
              country.ISOCode = "qa";
            } else if (this.eventDetails.country_id == 113) {
              country.CountryID = 113;
              country.CountryISOCode = "973";
              country.CountryName = "Bahrain";
              country.Flag =
                "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b50ad.png";
              country.ISOCode = "bh";
            } else if (this.eventDetails.country_id == 112) {
              country.CountryID = 112;
              country.CountryISOCode = "971";
              country.CountryName = "UAE";
              country.Flag =
                "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b51ad.png";
              country.ISOCode = "ae";
            }
            CountryService.saveCountry(country);
            EventBus.$emit("selectedCountry", country.CountryName);
            // CountryID: "175";
            // CountryISOCode: "974";
            // CountryName: "Qatar";
            // Flag: "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c77d4dc4e13c.jpg";
            // ISOCode: "qa";
            this.eventDetails.e_videos.map((data) => {
              if (data.e_video != null && data.e_video != "") {
                this.eventVideos.push({
                  thumbnail: `https://img.youtube.com/vi/${data.e_video}/0.jpg`,
                  url: `https://www.youtube.com/watch?v=${data.e_video}`,
                });
              }
            });
            console.log(
              "Schedule Data>>>",
              JSON.stringify(res.data.data.venue[0].auditorium[0].schedule)
            );
            this.addSelectedEvent(res.data.data);
            this.getEventSchedule(
              res.data.data.venue[0].auditorium[0].schedule
            );
          } else {
            console.log("Response Error ");
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },
    getEventSchedule(data) {
      this.eventSchedule = data.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              moment(t.es_date).format("YYYY-MM-DD") ===
              moment(value.es_date).format("YYYY-MM-DD")
          )
      );
      this.getEventTimings(
        this.eventSchedule[0].es_date,
        this.eventSchedule[0].event_schedule_id
      );
    },
    getEventTimings(date, id) {
      this.showLoading();
      const schedule = this.eventDetails.venue[0].auditorium[0].schedule;
      this.eventTimings = schedule.filter(
        (data, index) =>
          moment(data.es_date).format("YYYY-MM-DD") ==
          moment(date).format("YYYY-MM-DD")
      );
      this.selectedDate = id;
      this.hideLoading();
    },
    bookNowEvent() {
      if (!this.selected_schedule_id) {
        this.$toasted.show("Please Select Timings");
        setTimeout(() => {
          this.$toasted.clear();
        }, 5000);
      } else {
        if (
          this.eventDetails.venue[0].auditorium[0].booking_type.toLowerCase() ==
          "open"
        ) {
          if (
            this.eventDetails.additional_information != null &&
            this.eventDetails.additional_information != "null"
          ) {
            this.showLoading();
            this.$refs["eventAdditionalModal"].show();
            this.hideLoading();
          } else {
            this.showSeatTypeModal();
            // this.selected_schedule_id = 0;
          }
        } else {
          this.$router.push({
            path: "/event-seat-layout/" + this.selected_schedule_id,
          });
        }
      }
    },
    showAdditionalModal(id, data, type) {
      this.timingsData = data;
      this.selected_schedule_id = id;
      if (type == "single") {
        this.bookNowEvent();
      }
    },
    showSeatTypeModal() {
      // this.selected_schedule_id = id;
      this.hideAdditionalModal();
      this.showLoading();
      makeRequest(
        "/v1/event/getseattype/" + this.selected_schedule_id,
        "POST",
        null,
        null,
        this.url
      )
        .then((response) => {
          const { error, res } = response;
          if (!error) {
            this.eventSeatType = res.data.data;
            this.addSelectedSchedule(this.timingsData);
            this.$refs["eventSeatTypeModal"].show();
            // this.selected_schedule_id = 0;
            this.hideLoading();
          } else {
            console.log("Response Error ");
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },
    countSeatType(action, seatName, seatType) {
      if (this.checkSeatName(seatName)) {
        if (action == "add") {
          if (seatType.no_of_seat == undefined || seatType.no_of_seat <= 5) {
            this.$set(seatType, "no_of_seat", seatType["no_of_seat"] + 1 || 1);
            this.addSelectedSeats({ ...seatType });
          }
        } else {
          if (seatType.no_of_seat > 0) {
            this.$set(seatType, "no_of_seat", seatType["no_of_seat"] - 1);
            this.removeSelectedSeats({ ...seatType });
          }
        }
      }
      if (this.getSelectedSeats.length == 0) {
        // this.checkSeatName(seatName);
        const data = { seatname: seatName.aa_name };

        this.addSelectedSeatName({ data });
      }
    },
    checkSeatName(seatName) {
      return true;
      const data = { seatname: seatName.aa_name };

      if (
        this.getSelectedSeatName.length == 0 ||
        this.getSelectedSeats.length == 0 ||
        seatName.aa_name == this.getSelectedSeatName[0].data.seatname
      ) {
        this.addSelectedSeatName({ data });
        return true;
      } else {
        this.$toasted.show("You can choose only one category");
        setTimeout(() => {
          this.$toasted.clear();
        }, 5000);
        return false;
      }
    },
    hideSeatTypeModal() {
      this.$refs["eventSeatTypeModal"].hide();
      this.removeAllSelectedSeats([]);
      this.eventSeatName = null;
    },
    hideAdditionalModal() {
      this.$refs["eventAdditionalModal"].hide();
    },
    routePaymentPage() {
      this.showLoading();
      console.log(
        "this.getSelectedSeats.length11111",
        this.getSelectedSeats.length
      );
      console.log("first", this.getSelectedSeats);
      if (this.getSelectedSeats.length == 0) {
        this.$toasted.show("Please Select Seats");
        setTimeout(() => {
          this.$toasted.clear();
        }, 5000);
        this.hideLoading();
      } else {
        const { eventID } = this.$route.params;
        let country = CountryService.getCountry();
        let data1 = {
          seat_details: this.getSelectedSeats,
          CountryID: country.CountryID,
        };
        makeRequest(
          "/v1/event/eventreserve/" + this.selected_schedule_id,
          "POST",
          null,
          data1,
          this.url,
          false
        )
          .then((response) => {
            const { error, res } = response;
            this.hideLoading();
            if (error || res.error) {
              console.log("Response Error ");
              this.$toasted.show(res.error.message);
              setTimeout(() => {
                this.$toasted.clear();
              }, 5000);
            } else {
              this.$router.push({
                path: "/payment-summary/" + res.data.data.event_reserve_id,
              });
              this.hideLoading();
            }
          })
          .catch((error) => {
            this.hideLoading();
            // console.log("Error", error);
          });
        // this.$router.push({
        //   path: "/payment-summary",
        //   params: {
        //     props: { event_reserve_id: this.getSelectedSeats },
        //   },
        // });
      }
      // this.hideLoading();
    },
  },
};
</script>

<style>
.date-time-cursor {
  /* cursor: pointer; */
  /* text-decoration: underline; */
  color: #fff;
}
.event-date-slider .slick-prev {
  left: -1.5%;
}
.event-date-slider .slick-next {
  right: -1.5%;
}
.slick-disabled {
  z-index: -1 !important;
  /* cursor: not-allowed !important; */
}
.event-date-slider .slick-prev,
.event-date-slider .slick-next {
  width: 30px;
  height: 30px;
}

@media (min-width: 950px) {
  .event-date-slider {
    width: 98%;
    margin: auto;
  }
  .event-time-flex {
    width: 98%;
  }
  .event-details-header .event-banner-img {
    height: 488px !important;
  }
}

@media (max-width: 950px) {
  .event-date-slider {
    width: 88%;
    margin: auto;
  }
  .event-time-flex {
    width: 82%;
  }
  .event-date-slider .slick-prev {
    left: -8%;
  }
  .event-date-slider .slick-next {
    right: -8%;
  }
}

@media (max-width: 425px) {
  .event-details-header {
    border-radius: 0px !important;
  }
  .event-date-slider {
    width: 95%;
    margin: auto;
  }
  .event-time-flex {
    width: 95%;
  }
  .event-date-slider .slick-prev {
    left: -5%;
  }
  .event-date-slider .slick-next {
    right: -5%;
  }
  .event-date-slider .slick-prev,
  .event-date-slider .slick-next {
    width: 25px;
    height: 25px;
  }
}

.read-more span {
  background: transparent !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/eventDetails.vue